/**
 * Status Selector - Dropdown to change user status
 */

import React from 'react';
import { Menu, Space } from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { PresenceIndicator } from './PresenceIndicator';
import './StatusSelector.css';

interface StatusSelectorProps {
  currentStatus: 'online' | 'away' | 'busy' | 'offline';
  onStatusChange: (status: 'online' | 'away' | 'busy' | 'offline', autoStatus?: boolean) => void;
}

export const StatusSelector: React.FC<StatusSelectorProps> = ({
  currentStatus,
  onStatusChange,
}) => {
  const statuses = [
    { key: 'online', label: 'Online', color: '#2eb886' },
    { key: 'away', label: 'Away', color: '#f5a623' },
    { key: 'busy', label: 'Busy', color: '#e01e5a' },
    { key: 'offline', label: 'Offline', color: '#9e9ea6' },
  ];

  const handleStatusClick = async (status: string) => {
    const statusKey = status as 'online' | 'away' | 'busy' | 'offline';
    // Set manual status (autoStatus = false)
    onStatusChange(statusKey, false);
  };

  return (
    <div className="status-selector-menu" style={{ background: '#fff', borderRadius: 4, boxShadow: '0 2px 8px rgba(0,0,0,0.15)', minWidth: 250 }}>
      <Menu mode="vertical" style={{ border: 'none' }}>
        <Menu.ItemGroup title="Set Status">
          {statuses.map(status => (
            <Menu.Item
              key={status.key}
              onClick={() => handleStatusClick(status.key)}
              className="status-menu-item"
            >
              <Space>
                <PresenceIndicator status={status.key as any} />
                <span>{status.label}</span>
                {currentStatus === status.key && <CheckOutlined style={{ marginLeft: 'auto' }} />}
              </Space>
            </Menu.Item>
          ))}
        </Menu.ItemGroup>
      </Menu>
    </div>
  );
};

